import React from "react";
import PropTypes from "prop-types";
import { Panel } from "react-bootstrap";

const GroupCollection = props => {
	const { children, expanded, label, toggleGroup } = props;
	const isOpen = expanded ? "open" : "closed";

	return (
		<Panel onToggle={toggleGroup} expanded={expanded}>
			<Panel.Heading onClick={toggleGroup} style={{ cursor: "pointer" }}>
				<Panel.Title>
					<div className={`panel-toggle btn btn-primary ${isOpen}`}>
						<i className="fal fa-chevron-down icon"></i>
					</div>
					<div className="module-name">
						<span style={{ color: "rgba(0,0,0,0)" }}>|</span> {label}
					</div>
				</Panel.Title>
			</Panel.Heading>
			<Panel.Collapse>
				<Panel.Body>{children}</Panel.Body>
			</Panel.Collapse>
		</Panel>
	);
};

GroupCollection.propTypes = {
	children: PropTypes.any,
	expanded: PropTypes.bool,
	label: PropTypes.string,
	toggleGroup: PropTypes.func,
};

export default GroupCollection;
